
/* Bumble B — Personalization UI and Live Pricing */
(function () {
  'use strict';

  // Bumble B's Shopify Ajax prices use 100 units per KWD.
  function formatKWD(amount) {
    return (Number(amount || 0) / 100).toFixed(3) + ' KD';
  }

  function initialize(form) {
    if (form.dataset.bbInitialized === 'true') return;

    const root = form.querySelector(
      '[data-bb-personalization]'
    );

    const mapping = form.querySelector(
      '[data-bb-eligible-variants]'
    );

    const priceMapping = form.querySelector(
      '[data-bb-variant-prices]'
    );

    if (!root || !mapping || !priceMapping) return;

    let variants, prices;

    try {
      variants = JSON.parse(mapping.textContent);
      prices = JSON.parse(priceMapping.textContent);
    } catch (error) {
      console.error('[BB] Personalization data error:', error);
      return;
    }

    form.dataset.bbInitialized = 'true';

    const yes = root.querySelector('[value="yes"]');
    const no = root.querySelector('[value="no"]');

    const name = root.querySelector('[data-bb-name]');
    const nameWrap = root.querySelector('[data-bb-name-wrap]');
    const property = root.querySelector('[data-bb-property]');
    const error = root.querySelector('[data-bb-error]');

    const baseLabel = root.querySelector('[data-bb-base-label]');
    const baseDisplay = root.querySelector('[data-bb-base-price]');
    const feeRow = root.querySelector('[data-bb-fee-row]');
    const feeLabel = root.querySelector('[data-bb-fee-label]');
    const feeDisplay = root.querySelector('[data-bb-fee-price]');
    const totalDisplay = root.querySelector('[data-bb-total-price]');

    const embroideryPrice = Number(
      root.dataset.bbFeePrice || 0
    );

    function clearError() {
      name.setCustomValidity('');
      name.removeAttribute('aria-invalid');
      error.hidden = true;
    }

    function getQuantity() {
      const quantityInput = form.querySelector(
        'input[name="quantity"]'
      );

      const value = Number(quantityInput?.value || 1);

      return Number.isFinite(value) && value > 0
        ? value
        : 1;
    }

    function update() {
      const variantId = form.querySelector(
        '[name="id"]'
      )?.value;

      const eligible = variants[variantId] === true;

      root.hidden = !eligible;

      if (!eligible) {
        no.checked = true;
        yes.checked = false;
        name.value = '';
      }

      const active = eligible && yes.checked;

      // Required only if customer chooses Yes.
      nameWrap.hidden = !active;
      name.disabled = !active;
      name.required = active;
      name.setAttribute(
        'aria-required',
        String(active)
      );

      property.disabled = !active;
      feeRow.hidden = !active;

      if (!active) {
        clearError();
      }

      // Update variant and quantity pricing.
      const quantity = getQuantity();

      const unitPrice = Number(
        prices[variantId] || 0
      );

      const baseTotal = unitPrice * quantity;

      const embroideryTotal = active
        ? embroideryPrice * quantity
        : 0;

      const total = baseTotal + embroideryTotal;

      baseLabel.textContent = quantity > 1
        ? `Product price × ${quantity}`
        : 'Product price';

      baseDisplay.textContent = formatKWD(baseTotal);

      feeLabel.textContent = quantity > 1
        ? `Name embroidery × ${quantity}`
        : 'Name embroidery';

      feeDisplay.textContent =
        '+' + formatKWD(embroideryTotal);

      totalDisplay.textContent = formatKWD(total);
    }

    // Display an inline error when name validation fails.
    name.addEventListener('invalid', function () {
      name.setAttribute('aria-invalid', 'true');
      error.hidden = false;
    });

    name.addEventListener('input', function () {
      clearError();
    });

    // Respond to variant, Yes/No and quantity changes.
    form.addEventListener('change', function () {
      update();

      // Kalles sometimes updates its hidden variant
      // selector after the visible swatch change.
      setTimeout(update, 80);
      setTimeout(update, 220);
    });

    form.addEventListener('input', function (event) {
      if (
        event.target.matches(
          'input[name="quantity"], [name="id"]'
        )
      ) {
        update();
      }
    });

    // Support Kalles plus/minus quantity buttons.
    form.addEventListener('click', function (event) {
      if (
        event.target.closest('[data-quantity-selector]')
      ) {
        setTimeout(update, 0);
        setTimeout(update, 120);
      }
    });

    update();
  }

  function initializeAll() {
    document.querySelectorAll(
      'form.t4s-form__product'
    ).forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeAll
    );
  } else {
    initializeAll();
  }

  document.addEventListener(
    'shopify:section:load',
    initializeAll
  );
})();



/* Bumble B - Paid personalization / Kalles integration */
(function () {
  const processing = new WeakSet();

  const getRoot = () =>
    window.Shopify?.routes?.root || '/';

  function personalizationSelected(form) {
    const block = form.querySelector(
      '[data-bb-personalization]'
    );

    const mapping = form.querySelector(
      '[data-bb-eligible-variants]'
    );

    if (!block || !mapping) return false;

    const id = form.querySelector('[name="id"]')?.value;
    const yes = block.querySelector('input[value="yes"]');

    try {
      const variants = JSON.parse(mapping.textContent);

      return variants[id] === true && yes?.checked === true;
    } catch (error) {
      console.error('[BB] Variant mapping error:', error);
      return false;
    }
  }

  async function refreshMiniCart() {
    const root = getRoot();
    const drawer = document.querySelector('#t4s-mini_cart');

    if (!drawer) {
      throw new Error('Kalles drawer not found');
    }

    const response = await fetch(
      root + '?sections=mini_cart',
      {
        cache: 'no-store',
        credentials: 'same-origin'
      }
    );

    if (!response.ok) {
      throw new Error('Mini-cart section request failed');
    }

    const sections = await response.json();

    if (!sections.mini_cart) {
      throw new Error('Mini-cart HTML missing');
    }

    const template = document.createElement('template');
    template.innerHTML = sections.mini_cart;

    const selectors = [
      '[data-cart-items]',
      '[data-cart-prices]',
      '[data-cart-discounts]'
    ];

    // Require the two essential cart regions.
    for (const selector of selectors.slice(0, 2)) {
      if (
        !drawer.querySelector(selector) ||
        !template.content.querySelector(selector)
      ) {
        throw new Error(
          'Missing drawer region: ' + selector
        );
      }
    }

    selectors.forEach(selector => {
      const current = drawer.querySelector(selector);
      const updated = template.content.querySelector(selector);

      if (current && updated) {
        current.innerHTML = updated.innerHTML;
      }
    });

    const cartResponse = await fetch(root + 'cart.js', {
      cache: 'no-store'
    });

    if (!cartResponse.ok) {
      throw new Error('Cart verification failed');
    }

    const cart = await cartResponse.json();

    drawer.dataset.ccount = cart.item_count;

    console.log('[BB] Cart refreshed:', {
      itemCount: cart.item_count,
      lines: cart.items.length,
      subtotal: cart.items_subtotal_price
    });

    return cart;
  }

  async function addPersonalizedProduct(form, button) {
    if (processing.has(form)) return;

    const block = form.querySelector(
      '[data-bb-personalization]'
    );

    const input = block.querySelector('[data-bb-name]');
    const name = input.value.trim();

    if (!name) {
      input.setCustomValidity(
        'Please enter the name to be embroidered.'
      );
      input.reportValidity();
      input.focus();
      return;
    }

    input.setCustomValidity('');

    const feeId = Number(block.dataset.feeVariant);
    const data = new FormData(form);
    const productId = Number(data.get('id'));
    const quantity = Number(data.get('quantity') || 1);

    if (!feeId || !productId) {
      alert('Product or embroidery fee is not configured.');
      return;
    }

    if (!Number.isInteger(quantity) || quantity < 1) {
      alert('Invalid quantity.');
      return;
    }

    const properties = {};

    for (const [key, value] of data.entries()) {
      const match = key.match(/^properties\[(.+)\]$/);

      if (match && typeof value === 'string' && value.trim()) {
        properties[match[1]] = value.trim();
      }
    }

    const group =
      'bb-' + Date.now() + '-' +
      Math.random().toString(36).slice(2, 10);

    properties['Personalization'] = 'Yes';
    properties['Name Embroidery'] = name;
    properties['_bb_group'] = group;

    const productItem = {
      id: productId,
      quantity,
      properties
    };

    const sellingPlan = data.get('selling_plan');

    if (sellingPlan) {
      productItem.selling_plan = Number(sellingPlan);
    }

    const embroideryItem = {
      id: feeId,
      quantity,
      properties: {
        '_bb_group': group,
        '_bb_parent_variant': String(productId),
        'Name Embroidery': name
      }
    };

    processing.add(form);

    if (button) button.disabled = true;

    let added = false;

    try {
      console.log('[BB] Adding personalized product', {
        productId,
        feeId,
        quantity,
        name
      });

      const response = await fetch(
        getRoot() + 'cart/add.js',
        {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [productItem, embroideryItem]
          })
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.description || 'Unable to add to cart'
        );
      }

      added = true;

      console.log('[BB] Both items added successfully');

      // Ask Kalles to open/refresh its cart.
      document.dispatchEvent(
        new CustomEvent('cart:refresh:opend')
      );

      // Use the confirmed Bumble B mini_cart section.
      await refreshMiniCart();

    } catch (error) {
      console.error('[BB] Personalization error:', error);

      if (added) {
        // Product was added; show the accurate cart instead
        // of potentially displaying an outdated drawer.
        window.location.assign(getRoot() + 'cart');
      } else {
        alert(error.message || 'Unable to add product');
      }

    } finally {
      processing.delete(form);

      if (button) button.disabled = false;
    }
  }

  function intercept(event, form, button) {
    if (!form || !personalizationSelected(form)) {
      return;
    }

    // Stop Kalles' normal single-product add-to-cart.
    event.preventDefault();
    event.stopImmediatePropagation();

    if (processing.has(form)) return;

    addPersonalizedProduct(form, button);
  }

  // Capture Add to Cart clicks before Kalles handlers.
  window.addEventListener('click', function (event) {
    const target = event.target;

    if (!target?.closest) return;

    const button = target.closest('[data-atc-form]');

    if (!button || button.disabled) return;

    const form = button.closest('form.t4s-form__product');

    intercept(event, form, button);
  }, true);

  // Fallback for Enter-key and native form submissions.
  window.addEventListener('submit', function (event) {
    const form = event.target;

    if (!form.matches?.('form.t4s-form__product')) {
      return;
    }

    const button = form.querySelector('[data-atc-form]');

    intercept(event, form, button);
  }, true);

})();
